import getNextConfig from 'next/config';
import { useMemo } from 'react';
import {
  getConfigValue,
  getFeatureFlag,
  FEATURE_FLAG_KEYS,
  type ConfigKey,
  type FeatureFlagKey,
  type FeatureFlagState,
} from '@icommerce/hub-config';
import type { NextRuntimeConfiguration } from '@hub/libs/config';

export type { ConfigKey, FeatureFlagKey, FeatureFlagState };
export { FEATURE_FLAG_KEYS };

const runtimeEnvName = (getNextConfig() as NextRuntimeConfiguration).publicRuntimeConfig.envName;

export const getFeatureFlagValue = (key: FeatureFlagKey, env?: string | null): boolean =>
  getFeatureFlag(key, env ?? runtimeEnvName);

export const useFeatureFlag = (key: FeatureFlagKey): boolean => useMemo(() => getFeatureFlagValue(key), [key]);

export const getConfig = <K extends ConfigKey>(key: K, env?: string | null) =>
  getConfigValue(key, env ?? runtimeEnvName);

export const getFeatureFlags = (env?: string | null): FeatureFlagState[] =>
  FEATURE_FLAG_KEYS.map(name => ({
    name,
    value: getFeatureFlagValue(name, env),
  }));

export { getFeatureFlag };
